"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
var RequestToCorrectContent = () => {
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "mm-control-indent"
  }, /*#__PURE__*/_react.default.createElement("label", {
    for: 'ccpa-requestToCorrectText'
  }, "Additional Information for Request to correct*"), /*#__PURE__*/_react.default.createElement("p", null, "Describe what you want corrected, including:"), /*#__PURE__*/_react.default.createElement("ul", null, /*#__PURE__*/_react.default.createElement("li", null, "The category of information that is inaccurate (e.g. \u201Cmy last name\u201D)."), /*#__PURE__*/_react.default.createElement("li", null, "How you know the information is inaccurate (e.g. \u201CI see it on a letter I received about my policy dated XX/XX/XXXX). "), /*#__PURE__*/_react.default.createElement("li", null, "A good time to reach you by phone.")), /*#__PURE__*/_react.default.createElement("p", {
    className: "mm-spacing-minor"
  }, "Be sure not to provide any personal information."));
};
var _default = exports.default = RequestToCorrectContent;